import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RfCodeModel } from './rf-code.model';

export class RfCodesResponse extends GlobalResponseObject {
    data?: RfCodeModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RfCodeModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}